export default __webpack_public_path__ + "static/media/how-it-helps-2.1682ed8a.png";